import { useEffect, useState } from "react";
import axios from "axios";
import CompanyDetails from "./company-details";
import Representatives from "./representatives";
import IncidentDetails from "./incident-details";
import { useSelector, useDispatch } from "react-redux";
import { addblacklist } from "../redux/blacklist";
import AdditionalDocs from "./additional-docs";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";


const NewBlacklist = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const company = Cookies.get(`token_company`);
    const email = Cookies.get(`token_email`);
    const firstname = Cookies.get(`token_first_name`);
    const lastname = Cookies.get(`token_last_name`);
    const phone = Cookies.get(`token_phone`);

    const navigate = useNavigate();

    const test_blacklist = "http://localhost:3000/blacklist"
    const production_blacklist = "https://apple-tree-server.vercel.app/blacklist"



    const today = new Date();
    const userid = Number(Cookies.get(`token_id`));

    const dispatch = useDispatch();
    const blacklist = useSelector((state) => state.blacklist.value)

    const changeBlacklistState = () => {
        dispatch(addblacklist({
                userId: userid
            }))
        }
    
    const submitBlacklist = () => {
        setIsLoading(true)
        axios.post(production_blacklist,
            blacklist
        )
        .then((res) => {
            console.log(res)
            alert('Blacklist created successfully!' + ` Reference: ${res.data.reference}`)
            setIsLoading(false)
            props.setShowComplaint(false)
            props.setShowBlacklist(true)
        })
        .catch((err) => {
            console.log(err)
            alert(`Error occured: ${err}`)
            setIsLoading(false)
        })
    }

    useEffect(() => {
        changeBlacklistState()
    } ,[])

    const required = async (name, class_id) => {
        if (!name) {
            setError('Please enter all details')
            document.getElementById(class_id).classList.add('border-danger')
        }
}


    return ( 
        <div className={`container-fluid d-flex justify-content-center`}>
            <button className="btn btn-secondary mt-5 w-25" onClick={(e) => {
                e.preventDefault()
                console.log(blacklist)
                
            }}>
            </button>
            <form className={` border p-4 rounded w-100 mt-5  `} onSubmit={(e) => {
                }}>                    
                    <CompanyDetails/>

                    <Representatives/>

                    <IncidentDetails/>
                    
                    <AdditionalDocs/>

                    <p className="text-danger text-center">{error}</p>
                    <div className="mt-3 d-flex justify-content-center">
                        {!isLoading &&  <button class='btn btn-primary text-light' onClick={(e) => {
                            e.preventDefault();
                            submitBlacklist()}}>Submit</button>}
                        {isLoading && 
                        <button class="btn btn-secondary" type="button" disabled>
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        Loading...
                        </button>
                        }
                    </div>

                </form>
            </div>
     );
}
 
export default NewBlacklist;